import { Component, OnInit, EventEmitter } from '@angular/core';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';


import { GroupService } from '../../services/group.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

import { Utils } from '../../util';
import { Router } from '@angular/router';

@Component({
    selector: 'app-display-permission',
    templateUrl: './display-permission.component.html',
    styleUrls: ['./display-permission.component.css', '../../app.component.css']
})

export class DisplayPermissionComponent implements OnInit {
    allowed: boolean = false;
    permission: any = {};

    group = {};
    groupInit: any;
    groupText = '';
    groupId: string;

    globalActions = new EventEmitter<string|MaterializeAction>();

    runningFlag = false;

    ggSubs: any;
    ggpSubs: any;

    showPermissions = false;
    groupName = '';
    groupDescription = '';
    modules = [];

    permissions = [];
    permissionsObj: any = {};

    selectedItem = 0;

    constructor(
        private groupService: GroupService,
        private authService: AuthService,
        private permissionService: PermissionService,
        private router: Router
    ) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, 'permisos');
            if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
            else this.allowed = true;
        });

        this.loadGroups();
    }

    ngOnInit() {

    }

    loadGroups() {
        this.ggSubs = this.groupService.getGroups().subscribe(tempGroups => {
            this.ggSubs.unsubscribe();

            const dataGroup = {};

            for (const idx in tempGroups) {
                dataGroup[tempGroups[idx].name] = null;
                this.group[tempGroups[idx].name] = tempGroups[idx].id$;
            }

            this.groupInit = { 'data': dataGroup };
        });
    }

    onBlurGroup() {
        if (this.group[this.groupText] === undefined) {
            this.groupText = '';
            this.groupId = '';
        } else {
            this.groupId = this.group[this.groupText];
        }
    }

    getPermissions() {
        this.showPermissions = false;
        this.groupName = '';
        this.groupDescription = '';
        this.modules = [];

        this.runningFlag = true;

        if (this.groupId !== undefined && this.groupId !== '') {
            this.loadModules();
        } else {
            this.globalActions.emit('toast');
            this.runningFlag = false;
        }
    }
    onSpecial(){
        if(!this.groupId) return toast('Seleccione un grupo.', 2000);
        this.router.navigate([`/specialPermissions/${this.groupId}`]);
    }

    loadModules(){
        this.ggpSubs = this.groupService.getGroupPermission(this.groupId).subscribe(([{name, description, permission}]) => {
            this.ggpSubs.unsubscribe();

            this.groupName = name;
            this.groupDescription = description;

            this.generatePermissionObj(permission);

            const permissions = permission.sort(({level}, {level: level2}) => level > level2 ? 1 : -1).sort(({name},{name: name2}) => name > name2 ? 1 : -1);

            for (let item in permissions) {
                this.modules.push({ id: permissions[item].id$,
                                    name: permissions[item].name, level: permissions[item].level,
                                    create: permissions[item].createAction, read: permissions[item].readAction,
                                    update: permissions[item].updateAction, delete: permissions[item].deleteAction });
            }

            this.runningFlag = false;

            if (this.selectedItem !== 0) {
                const self = this;

                setTimeout(function() {
                    self.showPermissions = true;
                    window.scroll(0, self.selectedItem);
                }, 800);
            } else {
                this.showPermissions = true;
            }
        });
    }

    changePermission(id: string, action: string, changeTo: boolean) {
		if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
        let actionJson;

        this.selectedItem = window.pageYOffset;

        if (action === 'create') {
            actionJson = { createAction: changeTo };
        } else if (action === 'read') {
            actionJson = { readAction: changeTo };
        } else if (action === 'update') {
            actionJson = { updateAction: changeTo };
        } else if (action === 'delete') {
            actionJson = { deleteAction: changeTo };
        }

        this.groupService.putGroupPermission(this.groupId, id, actionJson).then(res => {
            this.modules = [];

            this.loadModules();
        });
    }

    generatePermissionObj(permissions){
        this.permissionsObj = {};

        //First level
        permissions.map((permission, index) => {
            let menu = permission.name.split('/')[0].trim();
            if(!this.permissionsObj[menu]) this.permissionsObj[menu] = [];
            this.permissionsObj[menu].push({...permission});
        });

        //Second level
        Object.keys(this.permissionsObj).map((key, index) => {
            let menu = [...this.permissionsObj[key]];
            let newMenu = {};
            menu.map((permission, index) => {
                let menu2 = permission.name.split('/')[1].trim();
                if(!newMenu[menu2]) newMenu[menu2] = [];
                if(permission.level == 3) newMenu[menu2].push({...permission});
                else newMenu[menu2] = {...permission};
            });
            this.permissionsObj[key] = newMenu;
        });
    }

    keysOf(object){
        return Object.keys(object);
    }

}
